import { Component, Inject, TemplateRef, ViewContainerRef } from '@angular/core';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { Order, BlueEXResponse } from '../../models/order/order.model';
import { BulkChangeOrderStatus } from '../../models/order/order.model';
import { OrderService } from '../../services/order/order.service';
import { CustomerService } from '../../services/customer/customer.service';
import { Customer } from '../../models/customer/customer-model';
import { EnumDropDown } from '../../models/shared/enum-dropdown';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RatingService } from '../../services/rating/rating.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
import { OrderViewModel, PrintOrdersList } from '../../models/order/order-view-model.model';
import { forEach } from '@angular/router/src/utils/collection';
import { Product } from '../../models/products/product.model';
import { $ } from 'protractor';
@Component({
    selector: 'app-order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.css']
})
/** order-list component*/
export class OrderListComponent {
  public orderList: Order[]=[];
  public bulkChechUnCheck: any;
  public searchKeyword: string = "";
  public customerPhone: string = "";
  public customerName: string = "";
  
  
  orderStatusId: string;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  public pagenumber: number=0;
  public rowsPerPage: number=10;
  public totalRecord: number=0;
  public showBoundaryLinks: boolean;
  public bulkOrderStatus: BulkChangeOrderStatus;
  public bulkOrderShipments: BulkChangeOrderStatus;
  public orderStatuses: EnumDropDown[]=[];
  //Filter items from grid
  filteredItems: any[]=[];
  public rowsOnPage: number;
  public customer: Customer;
  public customerList: Customer[];
  public arrRowsPerPage: number[];
  public orderChangeForStatus: number[] = [];
  public isChangeStatusAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  public isLoaded: boolean = false;
  public tracking: BlueEXResponse;
  public orderlist: PrintOrdersList[] = [];
  public isChecked: boolean = false;
  public orderListData: PrintOrdersList;
  public product: Product;
  public ProductList: Product[] = [];
  public orderDetailPrintComponent: string="";
  public discountRow: string = "";
  public subTotal: number=0;
  public total: number = 0;
  public paymentSaleAmount: number = 0;
  /** order-list ctor */
  constructor(private readonly orderService: OrderService,
    private readonly CustomerService: CustomerService,
    private readonly utilitiesService: UtilitiesService, private modalService: BsModalService,
    private readonly ratingService: RatingService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService) {
    this.pagenumber = 0;
    this.rowsOnPage = 10;
    this.rowsPerPage = 10;
    this.isLoaded = false;
    this.searchKeyword = "";
    this.customerPhone="";
    this.customerName="";
    this.orderStatusId = "";
    this.orderStatusId = "";
    this.discountRow = '';
    this.showBoundaryLinks = true;
    this.isChecked = false;
    this.rolePermissionService.GetRolePermissions("orderlist").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          var statusPermission = data.filter(function (element) {
            return (element.action == "status");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (statusPermission.length > 0)
            this.isChangeStatusAllowed = true;
          if (list.length > 0) {
          this.toastr.setRootViewContainerRef(vcr);
          this.OnFilterChange();
         
         // this.getCustomers();
            this.GetOrderStatuses();
           
         this.orderStatusId = "";
          this.bulkOrderShipments = new BulkChangeOrderStatus();
          this.bulkOrderStatus = new BulkChangeOrderStatus();
          this.bulkOrderStatus.orderIds = [];
          this.customerList = [];
            this.bulkOrderStatus.orderStatus = 0;
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  getOrders() {
    this.orderService.GetOrders().subscribe(
      data => {
        this.orderList = data;
        this.filteredItems = data;
      });
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.OnFilterChange();
    }
  }
  GetOrderStatuses() {
    this.orderService.GetOrderStatuses().subscribe(
      data => {
        this.orderStatuses = data;
      }
    )
  }
  TrackingDetail(trackingNumber: string) {

    this.orderService.TrackingDetail(trackingNumber).subscribe(
      data => {
        this.tracking = data;
        console.log(data);
        if (this.tracking.status == "1") {
          this.toastr.success(this.tracking.message, 'Success');
        }
        else {
          this.toastr.error(this.tracking.message, 'Error');
        }
      }
    )
  }
  TrackingDetailOnSite(trackingNumber: string) {

    var link = "https://www.blue-ex.com/tracking?trackno=" + trackingNumber;
    console.log(link);
    window.open(link, '_blank');
  }
  GenrateSiteMap(id: number)
  {
    alert("Serial Number: "+id);
  }
  UpdateCitiesCode() {
    this.orderService.UpateCities().subscribe(
      response => {
        if (response) {
          this.toastr.success('Cities Code Updated.', 'Success');
        } else {
          this.toastr.error('BlueEx Api Error', 'Error');
        }
      });

  }
  openCustomerModal(template: TemplateRef<any>, id) {
    this.ratingService.getCustomerInfo(id).subscribe(
      data => {
        if (data) {
         this.customer = data;
          if (this.customer.profileImagePath == null) {
            this.customer.profileImagePath = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
          }
          this.modalRef = this.modalService.show(template, this.config);
        }
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  getCustomers() {
    this.CustomerService.getCustomer().subscribe(
      data => {
        this.customerList = data;
      }
    )
  }
  BulkChangeOrderStatus() {
    if (this.orderChangeForStatus.length != 0 && this.bulkOrderStatus.orderStatus >0) {
      this.bulkOrderStatus.orderIds = this.orderChangeForStatus;
      this.orderService.BulkChangeStatus(this.bulkOrderStatus).subscribe(
        response => {
          if (response) {
            this.toastr.success('Order Status has been Update.', 'Success');
            this.bulkOrderStatus.orderIds = [];
            this.bulkOrderStatus.orderStatus = 0;
            this.orderChangeForStatus = [];
            setTimeout(() => {
             // this.getOrders();
              this.OnFilterChange();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Error');
          }
        }
      )
    }
    else {
      this.toastr.error('Please select any order to change status', 'Error');
    }
  }
  
  ifVendorExist(vendorID:number)
  {
    return (this.customerList.find(i => i.customerID == vendorID) == undefined);
  }
  createLabel()
  {
    if (this.orderChangeForStatus.length != 0 && this.orderChangeForStatus != undefined) {
      this.filteredItems = undefined;
      this.bulkOrderShipments.orderIds = this.orderChangeForStatus;
      this.orderService.Createlabel(this.bulkOrderShipments).subscribe(
        response => {
          this.orderChangeForStatus = [];
          this.bulkOrderShipments.orderIds = [];
          for(var i=0; i<response.length; i++)
          {
              this.toastr.error(response[i],"Error");
          }
         // this.getOrders();
          this.OnFilterChange();
         
        }
      )
    }
    else {
      confirm("Please select any order to create label");
    }
  }
  BulkListChangeStatus(orderID: number) {
    if (this.orderChangeForStatus.filter(i => i === orderID).length == 0) {
      this.orderChangeForStatus.push(orderID);
    }
    else {
      const index: number = this.orderChangeForStatus.indexOf(orderID);
      if (index !== -1) {
        this.orderChangeForStatus.splice(index, 1);

      }
    }
  }
  


  OnFilterChange() {
    this.pagenumber = 0;
    this.OnFilterChangegrid();
  }

  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.rowsPerPage = $event.itemsPerPage;

    this.OnFilterChangegrid();
  }
  OnFilterChangegrid() {
    this.isChecked = false;
    this.orderChangeForStatus = [];
    if (this.rowsPerPage == undefined) this.rowsPerPage = 10;
    if (this.pagenumber == undefined) this.pagenumber = 0;
    if (typeof this.orderStatusId == undefined) this.orderStatusId = "";
    this.orderService.GetOrdersGrid(this.pagenumber, this.rowsOnPage, this.orderStatusId, this.searchKeyword, this.customerName, this.customerPhone).subscribe(
      data => {
        this.isLoaded = true;
        this.orderList = data;
        console.log(data);
        console.log(this.orderList);
        if (this.orderList != null && this.orderList.length > 0)
          this.totalRecord = this.orderList[0].totalRecords;
        else
          this.totalRecord = 0;
        
      }
    )
  }

  bulkselectStatus() {
    if (this.isChecked) {

      this.orderList.forEach(order => {
        this.orderChangeForStatus.push(order.orderID);
        order.checked = true;
      });
    }
    else {
      this.orderChangeForStatus = [];
      this.orderList.forEach(order => {
        order.checked = false;
      });
    }
  }

  //for print of div 
  OnbulkPrint(): void  {
    if (this.orderChangeForStatus.length == 0) {
      this.toastr.error('Please select any order for Printing', 'Error');
      return ;
    }
    this.bulkOrderShipments.orderIds = this.orderChangeForStatus;
    this.orderService.PrintOrder(this.bulkOrderShipments).subscribe(
      data => {
        this.orderlist = data;

      
   
        var text = "";
        var counter = 0;
        var totalCounter = this.orderlist.length;
        this.orderlist.forEach(order => {
     
      this.orderDetailPrintComponent = '';
      for (var i = 0; i < order.orderDetails.length; i++) {
        if (order.orderDetails[i].purchaseOrderStatusID != 4
          && order.orderDetails[i].purchaseOrderStatusID != 5
        ) {
          this.product = new Product();
          this.product = order.products.filter(d => d.productID == order.orderDetails[i].productID)[0];

          this.orderDetailPrintComponent += '<tr><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">' + this.product.name + ' <br /> <small>' + this.product.sku + '</small></td ><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">' + order.orderDetails[i].productArrtibuteFields + ' <br /> <small>' + order.orderDetails[i].productArrtibuteValue + '</small></td ><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"> ' + order.orderDetails[i].quantity + '</td><td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"> ' + (order.orderDetails[i].price).toFixed(0) + '</td><td style = "text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"> ' + (order.orderDetails[i].price * order.orderDetails[i].quantity).toFixed(0) + '</td></tr>';
        }
      }
          if (order.order.couponAmount > 0) {
            this.discountRow = '<tr><td></td> <td></td><td></td> <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"><strong>Discount</strong></td> <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">-' + order.order.couponAmount + '</td></tr>';
          }
          else {
            this.discountRow = '';

          }
      if (order.order.shippingAddress == null) order.order.shippingAddress = "";
      if (order.order.shippingAddress == null) order.order.shippingAddress = "";
      if (order.customer.mobilePhone == null) order.customer.mobilePhone = "";

      //popupWin.document.write(`${printContents}`
      //);
      this.subTotal = 0;
      this.total = 0;
      this.paymentSaleAmount = 0;

      this.calculateSubtotal(order);

     

      text = text+`
        <div style="width:900px;margin:auto;">
            <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr><td colspan="2">&nbsp;</td></tr>
                <tr>
                    <td width="70%">
                       <img src="/Images/WebsiteImages/WebsiteLogo.jpg" width="250" alt=""/></td>
                    <td>
                       <!-- <strong>Incartoo.com</strong><br/> -->
                        <p>Office # 17 / N Block,<br/>
                            Main Blvd, Johar Town, Lahore Pakistan<br/>
                            info@arhamsoft.com<br/>
                            incartoo.com<br/>
                            Phone # +92.34.59666526
                        </p>
                    </td>
                </tr>
                <tr><td colspan="2">&nbsp;</td></tr>
                <tr>
                    <td>
                      <h1>INVOICE</h1>
                        <p>
                            ${order.customer.firstName} ${order.customer.lastName}<br/>
                           <strong class="address-col-heading">Shipping Address</strong>
                            ${order.order.shippingAddress}<br/>
                            ${order.order.shippingCity}<br/>
                            ${order.shippingState}<br/>
                            ${order.shippingCountry}<br/>
                            <a href="${order.customer.email}">${order.customer.email}</a><br/>
                            ${order.customer.mobilePhone}<br/>
                           <strong class="address-col-heading">Billing Address</strong>
                            ${order.customer.mainAddress}<br/>
                            ${order.order.shippingCity}<br/>
                            ${order.shippingState}<br/>
                            ${order.shippingCountry}<br/>
                        </p>
                    </td>
                    <td valign="top">
                        <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td>Order Number:</td>
                                <td>${order.order.orderID}</td>
                            </tr>
                            <tr>
                                <td>Order Date:</td>
                                <td>${order.order.orderDate}</td>
                            </tr>
                            <tr>
                                <td>Payment Method:</td>
                                <td>${order.strPaymentMethod}</td>
                            </tr>
                            <tr>
                                <td>Shipping Method:</td>
                                <td>${order.strShippingMethod}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr><td colspan="2" style="height:30px;">&nbsp;</td></tr>
                <tr>
                    <td colspan="2">
                        <table width="100%" cellpadding="0" cellspacing="0" border="0" align="left" b>
                            <tr>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Product</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Attributes</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Quantity</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Unit Price</th>
                                <th style="color:#000;text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;border-top:solid 1px #ccc;">Price Total</th>
                            </tr>
                            ${this.orderDetailPrintComponent}
                            <tr>
                                <td></td>
                                <td></td>
 <td></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;"><strong>Subtotal</strong></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 1px #ccc;">${(this.subTotal/* this.orderDetail.order.subTotal*/).toFixed(0)}</td>
                            </tr>
                            ${this.discountRow}
                            <tr>
                                <td></td>
                                <td></td>
 <td></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;"><strong>Shipping</strong></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;">${order.order.shippingPrice}</td>
                            </tr>
                            <tr>
                                <td></td>
                                 <td></td>
 <td></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;"><strong>Total</strong></td>
                                <td style="text-align:left;padding-left:5px;line-height:30px;border-bottom:solid 2px #000;">Rs <strong>${(this.total).toFixed(2)}</strong></td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr><td colspan="2" style="height:30px;">&nbsp;</td></tr>
            </table>
        </div>
<P class="page-break" style="page-break-after: always;clear: both;">
`;
          counter = counter+1;
      if (counter == totalCounter) {
        let printContents, popupWin;
         printContents = document.getElementById('print-section').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();

        popupWin.document.write(`<!DOCTYPE html>
<html xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta charset="utf-8"/>
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>
        <title>Order Invoice</title>
<style>
@media all {
.page-break { display: none; }
}

@media print {
.page-break { display: block; page-break-before: always; }
}
</style>
    </head>
    <body  onload="window.print();window.close()" style="padding:0;margin:0;font-family:Arial;font-size:12px;color:#000; line-height:20px;">
`+ text + `
    </body>
</html>
`);
        popupWin.document.close();

      }

    });
   });
  }
  calculateSubtotal(data: OrderViewModel) {
    this.subTotal = 0;
    for (var i = 0; i < data.orderDetails.length; i++) {
      if (data.orderDetails[i].purchaseOrderStatusID != 4
        && data.orderDetails[i].purchaseOrderStatusID != 5
      ) {

        //checking if we can add
           if (data.orderDetails[i].salePrice > 0) {
            this.subTotal += data.orderDetails[i].salePrice * data.orderDetails[i].quantity;
          }
          else {
            this.subTotal += data.orderDetails[i].price * data.orderDetails[i].quantity;
          }
        }
    }

    if (data.order.couponAmount == null || data.order.couponAmount == undefined) {
      data.order.couponAmount = 0;

    }
    this.paymentSaleAmount = data.order.paymentSaleAmount;
    this.total = (this.subTotal - data.order.couponAmount) + data.order.shippingPrice - (data.order.paymentSaleAmount);

  }
}



// WEBPACK FOOTER //
// ./src/app/order-components/order-list/order-list.component.ts